import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d71d45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-projects" }
const _hoisted_2 = {
  key: 0,
  class: "projects-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading projects...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "projects-error"
}
const _hoisted_7 = { class: "error-content" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"tech-legend\" data-v-65d71d45><h6 class=\"legend-title\" data-v-65d71d45>Project Focus</h6><div class=\"legend-items\" data-v-65d71d45><div class=\"legend-item\" data-v-65d71d45><span class=\"legend-tag domain-blockchain\" data-v-65d71d45>Blockchain &amp; Distributed Systems</span></div><div class=\"legend-item\" data-v-65d71d45><span class=\"legend-tag domain-security\" data-v-65d71d45>Security &amp; Privacy</span></div><div class=\"legend-item\" data-v-65d71d45><span class=\"legend-tag domain-science\" data-v-65d71d45>Science &amp; Research</span></div></div></div>", 1)
const _hoisted_10 = { class: "project-header" }
const _hoisted_11 = { class: "project-icon" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "project-info" }
const _hoisted_14 = { class: "project-title" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "project-meta" }
const _hoisted_20 = {
  key: 0,
  class: "project-org"
}
const _hoisted_21 = { class: "project-role" }
const _hoisted_22 = { class: "project-description" }
const _hoisted_23 = { class: "project-stats" }
const _hoisted_24 = { class: "stat-item" }
const _hoisted_25 = { class: "stat-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "stat-icon",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z" })
], -1))
const _hoisted_27 = { class: "stat-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "stat-icon",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 3.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 2.122a2.25 2.25 0 10-1.5 0v.878A2.25 2.25 0 005.75 8.5h1.5v2.128a2.251 2.251 0 101.5 0V8.5h1.5a2.25 2.25 0 002.25-2.25v-.878a2.25 2.25 0 10-1.5 0v.878a.75.75 0 01-.75.75h-4.5A.75.75 0 015 6.25v-.878zm3.75 7.378a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm3-8.75a.75.75 0 100-1.5.75.75 0 000 1.5z" })
], -1))
const _hoisted_29 = {
  key: 0,
  class: "topics-section"
}
const _hoisted_30 = { class: "topic-tags" }
const _hoisted_31 = {
  key: 0,
  class: "show-more-container"
}
const _hoisted_32 = {
  key: 0,
  class: "chevron-icon",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "chevron-icon",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 3,
  class: "projects-branding"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Open Source Projects", -1))
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ion_icon, {
                name: "code-slash-outline",
                class: "error-icon"
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_TransitionGroup, {
              name: "project-list",
              tag: "div",
              class: "projects-grid"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedProjects, (project) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: project.id,
                    class: "project-card"
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (project.logoUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: project.logoUrl,
                              alt: `${project.name} logo`,
                              class: "project-logo"
                            }, null, 8, _hoisted_12))
                          : (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 1,
                              name: "logo-github"
                            }))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h3", _hoisted_14, [
                          _createElementVNode("a", {
                            href: project.url,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, _toDisplayString(project.name), 9, _hoisted_15),
                          (project.websiteUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: project.websiteUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "website-link",
                                title: "Visit Website"
                              }, _hoisted_18, 8, _hoisted_16))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          (project.organization)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(project.organization), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(project.role), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", null, _toDisplayString(project.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['language-badge', _ctx.getLanguageClass(project.language)])
                        }, _toDisplayString(project.language), 3)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(project.stars)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(project.forks)), 1)
                      ])
                    ]),
                    (project.topics && project.topics.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.topics, (topic) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: topic,
                                class: _normalizeClass(['topic-tag', _ctx.getDomainClass(project.domain)])
                              }, _toDisplayString(topic), 3))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            (_ctx.projects.length > _ctx.initialDisplayCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowAll && _ctx.toggleShowAll(...args))),
                    class: "show-more-button"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.showAll ? 'Show Less' : `Show All (${_ctx.projects.length})`), 1),
                    (_ctx.showAll)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_34))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_35, _hoisted_37))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])),
    (_ctx.showBranding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
      : _createCommentVNode("", true)
  ]))
}